<template>
  <div id="index">
    <!-- 头部 -->
    <!-- <Hezuo></Hezuo> -->
    <HeaderTop :headIndex="8" ref="header"></HeaderTop>
    <!-- 个人展示 -->
    <div class="wrap" :class="main">
      <section class="user_div">
        <i><img src="@/assets/img/user_bg.png" alt=""></i>
        <div class="user flex_center">
          <img class="portrait" @click.stop="showPicture" :src="user.image" alt="">
          <h4 class="name">{{user.username}}</h4>
        </div>
        <h1 class="logo_title">
          个人中心
        </h1>
        <div class="flex_between user_button">
          <div class="button_left flex_center ">
            <span  class="setUp" v-if="user.check_status != 1" @click.stop="logOut" style="width:35px;font-size:28px;font-weight:bolder">
              <i class="el-icon-switch-button"></i>
            </span>
            <router-link to="/my_setUp" class="setUp" v-if="user.check_status == 1">
              <img src="@/assets/img/shezhe.png" alt="">
            </router-link>
            <span class="flex_center button_li">
              <i><img src="@/assets/img/huangguan.png" alt=""></i>
              {{MembershipType}}
            </span>
            <span class="flex_center button_li">
              <i><img src="@/assets/img/zhuanshi.png" alt=""></i>
              <span class="integral">{{user.score}}</span>积分
            </span>
          </div>
          <span class="button_rigth">
            <router-link to="/my_rules">
              规则详情
            </router-link>

          </span>
        </div>
      </section>
      <!-- 内容 -->
      <section class="flex_between center_div"  v-if="user.check_status == 1">
        <div class="center_left">
          <div class="flex_between tag_button">
            <router-link to="/my_focus" exact class="tag_button_li flex_center">
              <h4 class="tag_name">我的关注</h4>
              <h5 class="tag_num">{{user.follow}}</h5>
            </router-link>
            <router-link to="/my_collection" class="tag_button_li flex_center">
              <h4 class="tag_name">收藏</h4>
              <h5 class="tag_num">{{user.collect}}</h5>
            </router-link>
            <router-link to="/my_comments" class="tag_button_li flex_center">
              <h4 class="tag_name">评论</h4>
              <h5 class="tag_num">{{user.comment}}</h5>
            </router-link>
          </div>
          <div class="tag_button data_div">
            <div class="div_progress flex_between">
              <h5>基本信息完善</h5>
              <div class="portrait_center">
                <div class="progress_li">
                  <i :style="'width:'+user.percent+'%'"></i>
                </div>
                <span class="progress_text">已完成{{percent}}%</span>
              </div>
            </div>
            <div class="flex_center progress_slogan">
              <router-link to="/my_personal" class="flex_center">
                前往编辑<i><img src="@/assets/img/rigth_icon.png" alt=""></i>
              </router-link>
            </div>
          </div>
          <el-button class="exitLogin" @click.stop="logOut" type="danger" plain>退出登录</el-button>
        </div>
        <div class="center_rigth">
          <router-view ref="child"></router-view>
        </div>
      </section>
       <section v-else style="min-height:362px;position:relative">
        <div class="mask">
          <div style="text-align:center">
            <div v-if="user.check_status == 0" style="margin-bottom:5px;">审核状态：待审核</div>
            <br>
            <div v-if="user.check_status == 2" style="margin-bottom:5px">审核状态：审核拒绝</div>
            <br>
            <div v-if="user.check_status == 2">审核备注：{{user.check_remark}}</div><br>
            <div v-if="user.check_status == 0 || user.check_status == 2"><el-button type="primary" size="mini" style="margin:0 auto" @click="resubmit">重新提交</el-button></div>
          </div>
        </div>
        
       </section>
    </div>
    <!-- 修改头像 -->
    <ModifyPicture ref="picture" @getUser="getUser"></ModifyPicture>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from '@/components/assembly/HeaderTop.vue';//头部模块
import Footer from '@/components/assembly/Footer.vue';//尾部模块
import hot from '@/components/assembly/hot.vue';//热门模块
import listLi from '@/components/assembly/listLi.vue';//列表数据模块
import ModifyPicture from '@/components/assembly/ModifyPicture.vue';//修改头像模块
import Hezuo from '@/components/tool/hezuo.vue'

import "@/assets/js/currency.js";
import "@/assets/css/reset.css";

//pc端
// import "@/assets/css/index_min768.css";


export default {
  name: 'index',
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      tag_index: 1,//
      user: {},//用户数据
      main:'',
    }
  },
  computed: {
    MembershipType: function () {
      return this.MembershipGrade(this.user.plus);
    },
    percent: function () {
      if (this.user.percent)
        return parseInt(this.user.percent);
      else return 0
    }
  },
  components: {
    HeaderTop, Footer, Hezuo, hot, listLi, ModifyPicture
  },
  watch: {
    $route(to, from) {
      this.$store.commit('setParsonalPath', to.path)
      // 这里可以执行页面的刷新操作，比如重新获取数据
        this.REFRESH_USER();
        this.user = this.USER()
    }
  },
  methods: {
    resubmit(){
      this.$store.commit('setLoginUser', this.USER())
      this.$refs.header.registered(3);
    },
    beiChildMethod() {
      this.REFRESH_USER();
      let that = this;
      setTimeout(() => {
        that.getUser();
      }, 1000)
    },
    setUser(){
       this.$post('refresh', {
          mobile:this.USER().mobile
      }).then(res => {
         this.user = res.data
         console.log(this.user,'setUser');
      })
    },
    getUser() {
      let that = this;
      that.REFRESH_USER();
      that.user = this.USER();
      this.$nextTick(() => {
        if(that.user.check_status == 1){
          that.main = 'main'
        }else{
           that.main = 'main1'
        }
        that.$set(
          that.user,
          'follow',
          that.USER().follow,
        );
        that.$set(
          that.user,
          'collect',
          that.USER().collect,
        );
        that.$set(
          that.user,
          'comment',
          that.USER().comment,
        );
        that.$set(
          that.user,
          'image',
          that.USER().image,
        );
        that.$refs.header.getUser();
      })
    },
    showPicture() {//修改头像
      this.$refs.picture.pictureFun();
    },
    logOut() {//退出登录
      let that = this;
      layer.open({
        content: '您确定要退出登录吗？'
        , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
        , btn: ['确定', '取消']
        , yes: function (index) {
          // location.reload();
          layer.close(index);
          that.REMOVE_USER();
          that.$store.commit('setLoginUser', {})
          layer.open({
            content: '退出成功'
            , time: 1
            , skin: 'msg'
          });
          setTimeout(() => {
            that.$router.replace("/");
          }, 1000)
        }
      });

    },
  },
  created() {
  
  },
  mounted() {
    document.title = '个人中心';
    this.REFRESH_USER();
    this.getUser();
    this.JUDGE_USER();
    //加载关注页面
    this.$router.replace(this.$store.state.parsonal_path ? this.$store.state.parsonal_path : "/my_focus");
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace('/m_index');
    } else {
      // alert("pc端");
      // this.$router.replace('/index');

    }
  }
}
</script>
<style>
.router-link-active {
  text-decoration: none !important;
}
</style>
<style scoped>

.mask {
  	position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    /* width: 200px; */
    height: 120px;
}
.main1 {
  max-width: 1280px;
  min-width: 600px;
  margin: 0 auto;
  width: 100%;
  padding: 13px 0;
  align-items: flex-start;
}
.main {
  max-width: 1280px;
  min-width: 865px;
  margin: 0 auto;
  width: 100%;
  padding: 13px 0;
  align-items: flex-start;
}

#index {
  background: #f5f3fb;

  min-width: 1280px;
}

.user_div {
  height: 238px;
  border-radius: 10px;
  border: 1px solid #dfdfdf;
  background: #fff;
  position: relative;
}

.user_div .user {
  position: absolute;
  left: 100px;
  bottom: 33px;
}

.user_div .user .portrait {
  object-fit: contain;
  border-radius: 50%;
  border: 1px solid #f46f7a;
  width: 127px;
  height: 127px;
  margin-right: 16px;
  background: #fff;
}

.user_div .user .name {
  font-size: 18px;
  color: #fff;
}

.logo_title {
  position: absolute;
  right: 3%;
  top: 40%;
  transform: translateY(-50%);
  font-size: 42px;
  color: #fff;
}

.user_button {
  height: 62px;
  padding: 0 30px;
}

.user_button i {
  width: 35px;
  margin-right: 10px;
}

.user_button .setUp {
  margin-right: 194px;
  cursor: pointer;
}

.user_button .setUp > img {
  width: 35px;
}

.user_button .button_li {
  margin-right: 51px;
  font-size: 18px;
  color: #333;
}

.user_button .button_rigth {
  font-size: 18px;
  color: #333;
  cursor: pointer;
  text-decoration: underline;
}

.user_button .button_rigth .router-link-active {
  color: #ff0000;
}

.integral {
  color: #f5ab16;
  margin-right: 4px;
}

/* 内容 */
.center_div {
  margin-top: 12px;
  align-items: flex-start;
}

.center_div .center_left {
  width: 362px;
}

.center_left .tag_button {
  padding: 0 20px;
  background: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  margin-bottom: 12px;
}

.center_left .tag_button .tag_button_li {
  height: 110px;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  width: 30%;
  transition: all 0.5s ease;
}

.center_left .tag_button .tag_button_li .tag_name {
  font-size: 16px;
  color: 666;
  margin-bottom: 15px;
}

.center_left .tag_button .tag_button_li .tag_num {
  font-size: 20px;
  color: #333;
}

.center_left .tag_button .tag_button_li.router-link-active .tag_name {
  color: #f24d5b;
  text-decoration: none;
}

.center_left .tag_button .tag_button_li:hover {
  color: #fff;
  background: rgba(141, 76, 165, 0.8);
  border-radius: 10px;
}

.center_left .tag_button .tag_button_li:hover .tag_name {
  color: #fff;
}

.center_left .tag_button .tag_button_li:hover .tag_num {
  color: #fff;
}

.center_left .tag_button .tag_button_li.router-link-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 2px;
  background: #333;
  width: 66px;
}

.tag_button.data_div {
  padding: 0 29px;
}

.data_div .div_progress {
  height: 111px;
  border-bottom: 1px solid #dfdfdf;
}

.data_div .div_progress > h5 {
  font-size: 16px;
  color: #666;
  margin-right: 8px;
  white-space: nowrap;
}

.data_div .div_progress .portrait_center {
  flex: 1;
  position: relative;
}

.data_div .div_progress .portrait_center .progress_li {
  width: 100%;
  position: relative;
  border-radius: 3px;
  height: 5px;
  background: #dfdfdf;
}

.data_div .div_progress .portrait_center .progress_li > i {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  border-radius: 3px;
  height: 5px;
  background: #e89d00;
}

.data_div .div_progress .portrait_center .progress_text {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 100%);
  bottom: -10px;
  font-size: 14px;
  color: #333;
}

.progress_slogan {
  height: 48px;
}

.progress_slogan > a {
  font-size: 18px;
  color: #333;
}

.progress_slogan > a i {
  width: 12px;
  margin-left: 10px;
}

.progress_slogan a.router-link-active {
  color: #f00;
}

.center_div .center_rigth {
  width: calc(100% - 374px);
  background: #fff;
  min-height: 600px;
  border-radius: 10px;
  border: 1px solid #dfdfdf;
  padding: 20px 43px;
}

.exitLogin {
  width: 100%;
  height: 50px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/personal.vue